import {
  StyledAccordion,
  StyledAccordionItem,
  StyledContent,
  StyledSummary,
  StyledTitle,
  StyledTrigger
} from 'components/shared/accordion/Accordion.styled';
import styled from 'styled-components';
import {
  color,
  container,
  fontSize,
  fontWeight,
  radius,
  screen,
  spacing
} from 'theme';

export const StyledWrapper = styled.div`
  background-color: ${color('white')};
`;

export const StyledContainer = styled.div`
  max-width: ${container('lg')};
  margin: auto;
  text-align: left;
  padding: ${spacing('xl4')} ${spacing('md')};
`;

export const StyledDesc = styled.p`
  font-size: ${fontSize('lg')};
  line-height: 1.6;
`;

export const StyledSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing('xl')};
  padding-top: ${spacing('xl')};
  padding-bottom: ${spacing('xl')};
  border-bottom: 1px solid ${color('midnight_200')};

  @media (min-width: ${screen('md')}) {
    flex-direction: row;
  }
`;

export const StyledSectionContent = styled.div`
  max-width: 22rem;
  display: flex;
  flex-direction: column;
  gap: ${spacing('lg')};
  flex-grow: 1;

  p {
    margin-top: 0;
    line-height: 1.5;
  }

  ${StyledAccordion} {
    border: 1px solid ${color('midnight_200')};
    border-radius: ${radius('md')};
  }

  ${StyledAccordionItem}:first-child {
    ${StyledSummary} {
      border-top: 0;
    }
  }

  ${StyledTrigger} {
    padding: ${spacing('md')};
  }

  ${StyledTitle} {
    font-size: ${fontSize('md')};
  }

  ${StyledContent} {
    font-size: ${fontSize('md')};
    padding-left: ${spacing('md')};
    padding-right: ${spacing('md')};
  }
`;

export const StyledSectionTitle = styled.h6`
  font-size: ${fontSize('md')};
  font-weight: ${fontWeight('black')};
  color: ${color('text_subtle')};
  text-transform: uppercase;
  letter-spacing: 0.35em;
  margin: 0;

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('lg')};
  }
`;

export const StyledSectionChart = styled.div`
  flex-grow: 1;
`;

export const StyledThanks = styled.p`
  line-height: 1.5;
  padding-top: ${spacing('md')};

  a {
    font-weight: ${fontWeight('extraBold')};
  }
`;
